import { HeadRow, useDayPicker } from 'react-day-picker'

export const makeHead = (className: string) => {
  const Head = () => {
    const { styles, components } = useDayPicker()
    const HeadRowComponent = components?.HeadRow ?? HeadRow

    return (
      <thead style={styles.head} className={className}>
        <HeadRowComponent />
      </thead>
    )
  }

  return Head
}
